import { render } from "./FieldsToSignInfo.vue?vue&type=template&id=d6055c00"
import script from "./FieldsToSignInfo.vue?vue&type=script&lang=js"
export * from "./FieldsToSignInfo.vue?vue&type=script&lang=js"
script.render = render

export default script